import { logger } from 'utils/logger'
import { redirect } from 'utils/misc'

const handleResponse = async (res, url) => {
    switch (res.status) {
        case 200:
            logger.success(`Status ${res.status}, fetched: ${url}`)

            return res.text()

        case 400:
            logger.warn('400 Response: Unauthorized')

            throw new Error(`
                Fetch got 400
            `)

        case 500:
            throw new Error(`
                Fetch got 500
            `)

        default:
            throw new Error(`
                Failed in handleResponse. Status: ${res.status}
            `);
    }
}

const handleData = async (response) => {
    try {
        const data = JSON.parse(response) ?? response

        if (data && data.message) {
            return data
        }

        if (data && data.redirect) {
            redirect(data.redirect); 
            return; 
        }

        return data
    } catch (error) {
        return error
    }
}

export { handleResponse, handleData }
